import slice from "./costOverviewSlice";

export default slice.reducer;
